import * as React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../../defaultTheme";
import Heading, { StyledHeading } from "../../Heading";
import Text from "../../Text";
import { rtlSpacing } from "../../utils/rtl";
import media from "../../utils/mediaQuery";
export var StyledCardHeader = styled.div.withConfig({
  displayName: "CardHeader__StyledCardHeader",
  componentId: "lvjkay-0"
})(["position:relative;width:100%;padding:", ";box-sizing:border-box;color:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.spaceMedium;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.colorHeading;
}, media.desktop(css(["padding:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.spaceLarge;
})));
StyledCardHeader.defaultProps = {
  theme: defaultTheme
};
var StyledHeadingWrapper = styled.div.withConfig({
  displayName: "CardHeader__StyledHeadingWrapper",
  componentId: "lvjkay-1"
})(["display:flex;align-items:center;", "{width:100%;}"], StyledHeading);
var StyledSubTitle = styled.div.withConfig({
  displayName: "CardHeader__StyledSubTitle",
  componentId: "lvjkay-2"
})(["display:flex;margin-top:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.spaceXXSmall;
});
StyledSubTitle.defaultProps = {
  theme: defaultTheme
};
var StyledIcon = styled.div.withConfig({
  displayName: "CardHeader__StyledIcon",
  componentId: "lvjkay-3"
})(["color:", ";display:flex;align-items:center;margin:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.colorHeading;
}, function (_ref6) {
  var theme = _ref6.theme;
  return rtlSpacing("0 ".concat(theme.orbit.spaceSmall, " 0 0"));
});
StyledIcon.defaultProps = {
  theme: defaultTheme
};

var CardHeader = function CardHeader(_ref7) {
  var icon = _ref7.icon,
      title = _ref7.title,
      subTitle = _ref7.subTitle,
      actions = _ref7.actions,
      dataTest = _ref7.dataTest,
      dataA11ySection = _ref7.dataA11ySection;
  return React.createElement(StyledCardHeader, {
    "data-test": dataTest
  }, React.createElement(StyledHeadingWrapper, null, icon && React.createElement(StyledIcon, null, icon), React.createElement(Heading, {
    type: "title3",
    element: "h2",
    dataA11ySection: dataA11ySection
  }, title), actions), subTitle && React.createElement(StyledSubTitle, null, React.createElement(Text, null, subTitle)));
};

CardHeader.displayName = "CardHeader";
export default CardHeader;